export enum ReferenceType {
    Plan = "Plan",
}